export const convertMbpsToGbps = (downstreamSpeedInMbps: number) => {
  return downstreamSpeedInMbps >= 1000 ? `${downstreamSpeedInMbps / 1000} Gbps` : `${downstreamSpeedInMbps} Mbps`
}
